import { MODULES } from '../config/modules'
import { useSubscription } from './useSubscription'
import type { ModuleId } from '../types/module'

export function useModule(id: ModuleId) {
  const { isSubscribed } = useSubscription()
  return {
    config: MODULES[id],
    isSubscribed: isSubscribed(id),
  }
}
